<template lang="pug" src="./clients.pug"></template>

<script>
import { mapState, mapGetters } from 'vuex';
import { copyToClipboard } from '@/utils/helpers';

export default {
    data: () => ({
        requestProcessing: false
    }),
    computed: {
        ...mapGetters(['roleName', 'userBrandId', 'operator']),
        ...mapState({
            items: state => state.users.clients.items,
            pagination: state => state.users.clients.pagination
        }),
        headers() {
            const properties = ['userId', 'birthday', 'fullName', 'phoneNumber', 'email', 'comment'];

            if (!this.userBrandId) {
                properties.push('brandId');
            }

            if (this.canEditClients) {
                properties.push('actions');
            }

            return properties.map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Users.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        query: {
            get() {
                return this.$store.state.users.clients.filters.query;
            },
            set(val) {
                return this.$store.commit('users/SET_CLIENTS_QUERY', val);
            }
        },
        canEditClients: function() {
            return ['admin', 'boss', 'manager'].includes(this.roleName) || this.operator && this.operator.canEditClients;
        }
    },
    created() {
        this.$store.dispatch('data/getBrands');
        this.loadItems();
    },
    beforeDestroy() {
        this.$store.commit('users/RESET_CLIENTS_FILTERS');
    },
    methods: {
        copyToClipboard,
        loadItems(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('users/getClients', Object.assign({}, {
                q: this.query,
                page
            })).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        }
    }
};
</script>
